import "./style.scss";

import React, { FC } from "react";
import { ReactComponent as IconPay } from "assets/img/icons/payment/payStep.svg";
import { ReactComponent as IconUser } from "assets/img/icons/icon_User.svg";
import { ReactComponent as IconStatus } from "assets/img/icons/icon_status-Checked.svg";


interface IDPayStepperMenuProps {
    steps: { isCurrent: boolean; isDone: boolean }[];
    setSteps: (steps: { isCurrent: boolean; isDone: boolean }[]) => void;
    handleUpdateStep: (step: number) => void;
}

const IDPayStepperMenu: FC<IDPayStepperMenuProps> = ({ steps, setSteps, handleUpdateStep }) => {
    return (
        <div className="IDPayStepperMenu d-flex gap-2 flex-column align-items-center">
            <IconUser
                className="IDPayStepperMenu__icon"
                fill={steps[0].isDone ? "#17EB79" : steps[0].isCurrent ? "#1956A8" : "#9FC1EF"}
                onClick={() => steps[0].isDone && handleUpdateStep(0)}
            />
            <IconPay
                className="IDPayStepperMenu__icon"
                fill={
                    steps[1].isDone || steps[2].isDone
                        ? "#17EB79"
                        : steps[1].isCurrent || steps[2].isCurrent
                        ? "#1956A8"
                        : "#9FC1EF"
                }
                onClick={() => steps[1].isDone && handleUpdateStep(1)}
            />

            <IconStatus
                className="IDPayStepperMenu__icon"
                fill={steps[2].isDone ? "#17EB79" : steps[2].isCurrent ? "#1956A8" : "#9FC1EF"}
                onClick={() => steps[2].isDone && handleUpdateStep(2)}
            />
        </div>
    );
};

export default IDPayStepperMenu;
